import React, { useEffect, useState } from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  Avatar,
  Skeleton,
} from "@mui/material";
import freeVoteIcon from "../../../assets/customerAssets/icons/voteIcon.svg";
import freeVoteIconV from "../../../assets/customerAssets/freeVotesIcon.svg";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addVote  , addGuestVote} from "../../../api/addVote";
import { getGoalVotes } from "../../../api/getGoalVote";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import GuestUserRistModal from "../../Modals/user/guestUserModalRist/Modal";
import { handleGuestVoteFailure } from "../../../utils/guestVote";

const VoteComponent = ({ vote, id, count, setTournamentData }) => {
  const [clicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gcount, setCount] = useState(count);
  const [guestModal, setGuestModal] = useState(false);
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const loggedUser = useSelector((state) => state.loggedUser.user);
  const handleClicked = async () => {
    try {
      setLoading(true);
      if (loggedUser.device_id) {
        console.log(loggedUser,"logged user in vote component")
        const data = await addGuestVote(loggedUser.id, id, token, "professional_goal");
        if (data.success) {
          setCount((v) => v + 1);
          setTournamentData((data) => {
            const newGoals = data.professionalTournamentGoals.map((data) =>
              data.id == id
                ? { ...data, voteCount: data.voteCount + 1, isVoted: 1 }
                : data
            );
            const rankedGoals = newGoals.sort((a, b) =>
              a.voteCount > b.voteCount ? -1 : 1
            );
            return { ...data, professionalTournamentGoals: rankedGoals };
          });

          setLoading(false);
          setClicked(true);
          toast.success(data.message);
        } else {
          handleGuestVoteFailure(data, {
            onLimit: () => setGuestModal(true),
            onDisabled: (msg) => toast.error(msg || data.message),
          });
          toast.error(data.message);
        }
        return;
      }
      if (token && user.data.id) {
        const data = await addVote(user.data.id, id, token, true);
        if (data.success) {
          setCount((v) => v + 1);
          setTournamentData((data) => {
            const newGoals = data.professionalTournamentGoals.map((data) =>
              data.id == id
                ? { ...data, voteCount: data.voteCount + 1, isVoted: 1 }
                : data
            );
            const rankedGoals = newGoals.sort((a, b) =>
              a.voteCount > b.voteCount ? -1 : 1
            );
            return { ...data, professionalTournamentGoals: rankedGoals };
          });

          setLoading(false);
          setClicked(true);
          dispatch({ type: "DCREMENT_VOTE" });
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } else {
      }
    } catch (error) {
      if (error.guestVotingDisabled) {
        toast.error(error.message);
      } else if (error.requiresRegistration) {
        setGuestModal(true);
      }
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <GuestUserRistModal open={guestModal} setOpen={setGuestModal} />
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Button className="icon-div" onClick={handleClicked}>
          {loading ? (
            <Skeleton animation="wave" height={27} width={27} />
          ) : (
            <img
              src={vote || clicked ? freeVoteIconV : freeVoteIcon}
              className="iconImg"
            />
          )}
        </Button>
      </Box>
    </>
  );
};

export default VoteComponent;
